import React from 'react'
import { Button, Typography } from '@mui/material'

interface LinkButtonProps {
  text: string
  handleLink?: () => void
}

export const LinkButton: React.VFC<LinkButtonProps> = ({ text, handleLink }): JSX.Element => {
  return (
    <Button
      color="primary"
      variant="outlined"
      onClick={handleLink}
      sx={{
        bgcolor:'#FFFFFF',
        width: '110px',
        height: '42px',
        marginBottom: '20px'
      }}
    >
      <Typography
        sx={{
          fontStyle: 'normal',
          fontSize: 15,
          lineHeight: '26px',
        }}
      >
        {text}
      </Typography>
    </Button>
  )
}
